import { referralSettingsOverrideSchema } from "./referral";
import z from "zod";

export const adminGenerateReferralCodeSchema = z.object({
  defiAddress: z.string().min(1),
  referralCode: z.string().min(1),
  expiresAt: z.coerce.date().optional(),
  referralSettingsOverride: referralSettingsOverrideSchema.optional(),
});

export type AdminGenerateReferralCodeDtoType = z.infer<typeof adminGenerateReferralCodeSchema>;

export const adminCreateReferralSchema = z
  .object({
    referrerDefiAddress: z.string().min(1),
    refereeDefiAddress: z.string().min(1),
  })
  .refine((data) => data.referrerDefiAddress.toLowerCase() !== data.refereeDefiAddress.toLowerCase(), {
    message: "referrer and referee must be different",
    path: ["refereeDefiAddress"],
  });

export type AdminCreateReferralDtoType = z.infer<typeof adminCreateReferralSchema>;

export const adminBuildReferralEpochsForRangeSchema = z
  .object({
    start: z.coerce.date(),
    end: z.coerce.date(),
  })
  .refine((data) => data.start.getTime() <= data.end.getTime(), {
    message: "start must be before or equal to end",
    path: ["start"],
  });

export type AdminBuildReferralEpochsForRangeDtoType = z.infer<typeof adminBuildReferralEpochsForRangeSchema>;

export const adminBackfillReferralEpochVolumesForRangeSchema = z
  .object({
    start: z.coerce.date(),
    end: z.coerce.date(),
  })
  .refine((data) => data.start.getTime() <= data.end.getTime(), {
    message: "start must be before or equal to end",
    path: ["start"],
  });

export type AdminBackfillReferralEpochVolumesForRangeDtoType = z.infer<
  typeof adminBackfillReferralEpochVolumesForRangeSchema
>;

export const adminRepublishUnclaimedMerkleForRangeSchema = z.object({
  epochIds: z.array(z.number().int().nonnegative()).min(1, "epochIds must contain at least one id"),
});

export type AdminRepublishUnclaimedMerkleForRangeDtoType = z.infer<typeof adminRepublishUnclaimedMerkleForRangeSchema>;

export const adminGetReferralEpochRewardsStatsSchema = z
  .object({
    start: z.coerce.date(),
    end: z.coerce.date(),
  })
  .refine((data) => data.start.getTime() <= data.end.getTime(), {
    message: "start must be before or equal to end",
    path: ["start"],
  });

export type AdminGetReferralEpochRewardsStatsDtoType = z.infer<typeof adminGetReferralEpochRewardsStatsSchema>;

export type AdminReferralEpochRewardsStatsResponse = {
  start: string;
  end: string;
  rewardTokenSymbol: string;
  totalRewardAmount: number;
  totalVolumeUSD: number;
  byUser: Array<{
    hubUserId: number;
    defiAddress: string;
    totalRewardAmount: number;
    totalVolumeUSD: number;
  }>;
};
